// extracted by mini-css-extract-plugin
module.exports = {"main":"cookiePolicy-module--main--1rvZK","ul":"cookiePolicy-module--ul--3KHM9","content":"cookiePolicy-module--content--1iKKR","line":"cookiePolicy-module--line--3Obg7"};